import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import MobileFooter from './MobileFooter';
import { Container, Heading, Eyebrow, Card } from '../ui';

const SECTIONS = [
  {
    title: "Intellectual Property",
    body: "This digital directory platform, including its source code, design, features, and content, is the exclusive property of Thulir Technology.",
  },
  {
    title: "License to KBC",
    body: "A whitelabel version of this platform has been licensed to Kongu Business Community (KBC) for their operational use. This license does not transfer any ownership or intellectual property rights.",
  },
  {
    title: "Restricted Use",
    body: "No part of this website or its underlying technology may be copied, cloned, modified, distributed, or repurposed for any other client, community, or commercial purpose without the prior written consent of Thulir Technology.",
  },
  {
    title: "Legal Protection",
    body: "Unauthorized duplication, imitation, or misuse of this website may constitute intellectual property infringement and will be pursued under applicable civil and criminal laws.",
  },
];

const LegalNotice = () => {
  return (
    <div className="min-h-screen bg-bg pb-20 lg:pb-0 font-sans">
      <Header />

      {/* Hero */}
      <div className="on-dark bg-navy py-14 sm:py-20 px-4">
        <Container width="wide" className="text-left">
          <Eyebrow>Legal</Eyebrow>
          <Heading variant="display" className="mt-4 text-3xl sm:text-4xl md:text-5xl">
            Legal Notice / <em className="kbc-serif">Terms</em> of Use
          </Heading>
          <p className="mt-3 text-sm sm:text-base text-muted">
            © 2025 Thulir Technology. All rights reserved.
          </p>
        </Container>
      </div>

      {/* Content */}
      <Container width="wide" className="py-10 sm:py-14 md:py-16">
        <div className="space-y-6 text-left">
          {SECTIONS.map((section) => (
            <Card key={section.title} padding="lg">
              <Heading as="h2" variant="title" className="mb-3 text-2xl sm:text-3xl">
                {section.title}
              </Heading>
              <p className="text-[0.95rem] sm:text-base leading-relaxed text-text">
                {section.body}
              </p>
            </Card>
          ))}
        </div>
      </Container>

      <Footer />
      <MobileFooter />
    </div>
  );
};

export default LegalNotice;
